import { useMutation, useQueryClient } from '@tanstack/react-query';
import { del } from '@truefit/http-utils';
import { useSnackbar } from 'notistack';
import { WEBHOOKS_QUERY_KEY } from './useDispatchWebhooksQuery';

export const useDeleteDispatchWebhookMutation = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (id: number) => {
      await del(`/v1.0/clip-dispatch/webhooks/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: WEBHOOKS_QUERY_KEY });
      enqueueSnackbar('Webhook removed', { variant: 'success' });
    },
    onError: (error: any) => {
      enqueueSnackbar(error?.response?.data?.error || 'Failed to remove webhook', { variant: 'error' });
    },
  });
};
